function syncCartDrawerFooterSlot() {
  const giftJump = document.querySelector('[data-cart-gift-boxes-jump]');
  const lookJump = document.querySelector('.drawer__footer [data-cart-drawer-upsell-toggle]');
  const inlineJump = document.querySelector('[data-cart-drawer-upsell] > [data-cart-drawer-upsell-toggle]');
  const block = document.querySelector('cart-drawer [data-cart-drawer-upsell]');
  const isOpen = Boolean(block?.classList.contains('is-open'));

  if (isOpen) {
    if (lookJump) lookJump.hidden = true;
    if (inlineJump) inlineJump.hidden = false;
    return;
  }

  if (!lookJump) {
    if (inlineJump) inlineJump.hidden = false;
    return;
  }

  const giftTakesSlot = Boolean(giftJump) && !giftJump.hidden;
  lookJump.hidden = giftTakesSlot;
  if (inlineJump) inlineJump.hidden = !lookJump.hidden;
}

function setCartDrawerUpsellOpen(block, isOpen, { scroll = false } = {}) {
  window.__cartDrawerUpsellOpen = Boolean(isOpen);
  if (block) block.classList.toggle('is-open', isOpen);

  const panel = block?.querySelector('.cart-drawer-upsell__panel');
  if (panel) panel.hidden = !isOpen;

  document.querySelectorAll('[data-cart-drawer-upsell-toggle]').forEach((toggle) => {
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  syncCartDrawerFooterSlot();

  if (isOpen && block) {
    const scroller = block.closest('cart-drawer-items') || document.querySelector('cart-drawer cart-drawer-items');
    if (scroller) {
      const pin = () => {
        scroller.scrollTop = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      };
      requestAnimationFrame(() => requestAnimationFrame(pin));
    }
  }
}

let cartDrawerUpsellJumpState = null;

function teardownCartDrawerUpsellJump() {
  cartDrawerUpsellJumpState?.observer?.disconnect();
  cartDrawerUpsellJumpState?.scroller?.removeEventListener('scroll', cartDrawerUpsellJumpState.update);
  cartDrawerUpsellJumpState = null;
}

function bindCartDrawerUpsellVisibility() {
  teardownCartDrawerUpsellJump();

  const scroller = document.querySelector('cart-drawer cart-drawer-items');
  const section = document.querySelector('cart-drawer [data-cart-drawer-upsell]');
  if (!scroller || !section) {
    syncCartDrawerFooterSlot();
    return;
  }

  const update = () => syncCartDrawerFooterSlot();
  const observer = new IntersectionObserver(update, {
    root: scroller,
    threshold: [0, 0.05, 0.2],
  });
  observer.observe(section);
  scroller.addEventListener('scroll', update, { passive: true });
  update();

  cartDrawerUpsellJumpState = { observer, scroller, update };
}

function initCartDrawerUpsell(root = document, maybeOptions = {}) {
  let options = maybeOptions;
  if (root && typeof root === 'object' && !(root instanceof Element) && !root.querySelectorAll) {
    options = root;
    root = document;
  }

  const resetClosed = Boolean(options.resetClosed);
  if (resetClosed) window.__cartDrawerUpsellOpen = false;

  const scope = root.querySelectorAll ? root : document;
  const block =
    scope.querySelector?.('[data-cart-drawer-upsell]') || document.querySelector('[data-cart-drawer-upsell]');
  const isOpen = resetClosed ? false : Boolean(window.__cartDrawerUpsellOpen);
  setCartDrawerUpsellOpen(block, isOpen);
  bindCartDrawerUpsellVisibility();
}

function bindCartDrawerUpsellToggle() {
  if (window.__cartDrawerUpsellToggleBound) return;
  window.__cartDrawerUpsellToggleBound = true;

  document.addEventListener(
    'click',
    (event) => {
      const toggle = event.target.closest('[data-cart-drawer-upsell-toggle]');
      if (!toggle) return;
      if (!toggle.closest('cart-drawer')) return;

      event.preventDefault();
      const block = document.querySelector('cart-drawer [data-cart-drawer-upsell]');
      if (!block) return;

      setCartDrawerUpsellOpen(block, !block.classList.contains('is-open'), { scroll: true });
    },
    true
  );
}

bindCartDrawerUpsellToggle();
window.initCartDrawerUpsell = initCartDrawerUpsell;
window.setCartDrawerUpsellOpen = setCartDrawerUpsellOpen;
window.syncCartDrawerFooterSlot = syncCartDrawerFooterSlot;

document.addEventListener('DOMContentLoaded', initCartDrawerUpsell);
document.addEventListener('shopify:section:load', initCartDrawerUpsell);
